module.exports = __webpack_public_path__ + "static/img/park-3.955eb529.png";